/**** WARNING: This is a generated file, so any changes might get overwritten! ****/
const _t = (window as any).vvTranslations?.Address || {};
export * from './Common.ts';
export const Loading = (): string => _t.Loading ?? "Loading...";
export const AddressOkay = (): string => _t.AddressOkay ?? "Address Okay";
export const AddressNotOkay = (): string => _t.AddressNotOkay ?? "Sorry! We can't find that address";
export const StreetAddress = (): string => _t.StreetAddress ?? "Street Address";
export const StreetAddressPlaceholder = (): string => _t.StreetAddressPlaceholder ?? "Enter Street Address";
export const Zip = (): string => _t.Zip ?? "Zip";
export const ZipPlaceholder = (): string => _t.ZipPlaceholder ?? "Enter Zip";
export const City = (): string => _t.City ?? "City";
export const Clear = (): string => _t.Clear ?? "Clear";
export const ClearAll = (): string => _t.ClearAll ?? "Clear All";
export const Edit = (): string => _t.Edit ?? "Edit";
export const EditTooltip = (): string => _t.EditTooltip ?? "Edit Address";
export const Continue = (): string => _t.Continue ?? "Continue";
export const Address = (): string => _t.Address ?? "Address";
export const Home = (): string => _t.Home ?? "Home";
export const HomeAddress = (): string => _t.HomeAddress ?? "Home Address";
export const Business = (): string => _t.Business ?? "Business";
export const BusinessAddress = (): string => _t.BusinessAddress ?? "Business Address";
